
export const replaceBetween = (origin:string, start: number, end: number, replacement: string) => {
    return `${origin.substring(0, start)}${replacement}${origin.substring(end)}`;
}

export const getSlug = (text: string) => {
    //return text.toString().replaceAll(" ", "-").toLowerCase();
    return text.replace(/ /g, '-').toLowerCase();
}